import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from '@mui/material';
import { useCommonDispatcher } from 'hooks';
import { Icons } from 'components';
import { reportFactorsDetailsDebtor } from '../../services/DetailAccountsServices';

const MultiInvoice = ({ rowData }) => {
  let content = '';
  const setDialog = useCommonDispatcher();

  const showDetailMultiInvoice = async (rowData) => {
    setDialog({
      title: `جزییات فاکتور تسهیمی به شماره "${rowData.invoiceId}"`,
      open: true,
      loading: true,
    });

    const params = {
      size: 1,
      offset: 0,
      id: rowData.invoiceId, // ID test '148744'
    };

    let res = await reportFactorsDetailsDebtor(params);
    res = res.result[0];

    const content = (
      <>
        {res?.subInvoices.map((row) => (
          <Accordion key={row.id}>
            <AccordionSummary
              expandIcon={<Icons icon="CaretDown" color="#667585" size="20" />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Grid container justifyContent="center" alignItems="center">
                <Typography>
                  فاکتور شماره "<b>{row.id}</b>" برای "<b>{row.business.name}</b>" به میزان "
                  <b>{row.totalAmount}</b>"
                </Typography>
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container justifyContent="center">
                <TableContainer component={Paper} style={{ maxWidth: '70%' }}>
                  <Table aria-label="spanning table">
                    <TableHead>
                      <TableRow>
                        <TableCell>شرح</TableCell>
                        <TableCell align="right">فی</TableCell>
                        <TableCell align="right">تعداد</TableCell>
                        <TableCell align="right">جمع</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row.invoiceItemSrvs.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>{row.description}</TableCell>
                          <TableCell align="right">{row.amount}</TableCell>
                          <TableCell align="right">{row.quantity}</TableCell>
                          <TableCell align="right">{row.amount * row.quantity}</TableCell>
                        </TableRow>
                      ))}

                      <TableRow>
                        <TableCell colSpan={2} />
                        <TableCell>مالیات</TableCell>
                        <TableCell align="right" />
                      </TableRow>

                      <TableRow>
                        <TableCell colSpan={2} />
                        <TableCell>جمع کل</TableCell>
                        <TableCell align="right">{row.totalAmount}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))}
      </>
    );

    setDialog((prev) => ({ ...prev, content, loading: false }));
  };

  if (rowData.hasMultiInvoice === 'خیر') {
    content = (
       <Chip
        size={'small'}
        style={{ backgroundColor: '#e3f2fd', fontSize: 11 }}
        label="خیر"
        icon={<Icons icon="Share" color="#2B3990" size="18" />}
        disabled
      />
   
    );
  } else {
    if (rowData.mainMultiInvoice === 'بلی') {
  // فاکتور اصلی
   <Chip
        size={'small'}
        style={{ backgroundColor: '#e3f2fd', fontSize: 11 }}
        label="اصلی"
        icon={<Icons icon="Share" color="#2B3990"  size="18" />}
        onClick={() => showDetailMultiInvoice(rowData)}
      />
    }else{
   // ذینفع 
    content = (
      <Chip
        size={'small'}
        style={{ backgroundColor: '#e3f2fd', fontSize: 11 }}
        label="ذینفع"
        icon={<Icons icon="Share" color="#2B3990" size="18" />}
        disabled
      />
    );
    }
  } 

  return content;
};

export default MultiInvoice;
